import {
  ElementRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RigSummary } from '@models/rig.interface';

@Component({
  selector: 'app-rig-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './rig-list.component.html',
  styleUrl: './rig-list.component.scss'
})
export class RigListComponent implements OnChanges {
  private readonly hostElement = inject(ElementRef<HTMLElement>);

  @Input() rigs: RigSummary[] = [];
  @Input() selectedId: number | null = null;

  @Output() rigSelected = new EventEmitter<RigSummary>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['name', 'alias', 'defaultBusinessUnitName', 'actions'];

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['selectedId'] && !changes['rigs']) return;

    setTimeout(() => this.scrollToSelectedRow());
  }

  onRowClick(rig: RigSummary): void {
    this.rigSelected.emit(rig);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onDeleteClick(rig: RigSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(rig.id);
  }

  private scrollToSelectedRow(): void {
    if (this.selectedId === null) return;

    const row = this.hostElement.nativeElement.querySelector(
      `tr[data-rig-id="${this.selectedId}"]`
    ) as HTMLElement | null;

    row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
